module.exports = "<i class=\"u-icon icon-32 icon-copy\"  (click)=\"beforeCopy()\"></i>"